export default {"src":"/_next/static/media/house_with_key_40.0d4c49c7.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};